import ContentOverlay from "components/ContentOverlay";
import React, { useCallback } from "react";
import { CellRenderers } from "utils/tableUtils";
import { useFindingDetails } from "../FindingDetailsProvider";
import { LoadingIcon } from "components/Icons";
import EditIconButton from "components/EditIconButton";
import { hasPermission } from "utils/authService";
import { PermissionSetMap } from "constants/RBACConstants";

export default function Summary() {
  const {
    finding = {},
    loading,
    isCustomFinding,
    openFindingFieldEditPopup,
  } = useFindingDetails();
  const { title } = finding;

  const editTitle = useCallback(() => {
    openFindingFieldEditPopup("title");
  }, [openFindingFieldEditPopup]);

  if (loading) {
    return <LoadingIcon />;
  }

  return (
    <div className="d-flex">
      <ContentOverlay
        className="markdown-text"
        contentClass="d-flex"
        content={CellRenderers.VALUE_OR_NA(title)}
      />
      {isCustomFinding ? (
        <EditIconButton
          disabled={!hasPermission(PermissionSetMap.UPDATE_FINDINGS)}
          onClick={editTitle}
        />
      ) : null}
    </div>
  );
}
